import { FormSection } from "components/MainSectionTemplate/types";
import { YesNoRadioGroupForInPageEditing, YesNoText } from "components/ValidatedFields/YesNoRadioGroup";
import React from "react";

interface Props {
  config: server.dto.ClientConfiguration
  instruction: server.dto.UpdateClientConfigurationInstruction
}

export const GeneralSection = (props: Props): FormSection => {
  return {
    key: "generalSystemSettings",
    type: "regular",
    title: RESX.GeneralLabels.General,
    fields: [{
      key: "general_projectCode",
      label: RESX.Show.ProjectCode,
      render: () => <YesNoText value={props.instruction.projectCodeEnabled || props.config.projectCode === "displayBusinessCentral"} />,
      editDisabled: props.config.projectCode === "displayBusinessCentral",
      inPageEdit: {
        render: ({ onChange }) => <YesNoRadioGroupForInPageEditing
          value={props.instruction.projectCodeEnabled}
          onChange={(v) => onChange(v, true)}
        />,
        type: "custom",
        initialValue: props.instruction.projectCodeEnabled,
        submitChange: (value: boolean) => {
          return window.CoreApi.ClientConfiguration.Update({ ...props.instruction, projectCodeEnabled: value });
        }
      }
    }]
  }
}